import { useRef } from 'react';

import { Box, Button } from '@mui/material';

import { useListagemContext } from 'context/ListagemContext';
import { useDownloadFile } from 'hooks/useDownloadFile';
import { RequestOptionsType } from 'hooks/useRequestListagem';
import { useConsultaReembolsoContext } from 'pages/financeiro/reembolso/consulta-reembolso/contexts';

export function ConsultaReembolsoDownload() {
    const { filter } = useListagemContext();
    const { hasReembolsos } = useConsultaReembolsoContext();
    const downloadType = useRef<null | 'sintetico' | 'analitico'>(null);

    const requestOptions: RequestOptionsType = {
        url: '',
        sort: [{ property: 'idApuracao', direction: 'DESC' }],
        filter,
    };

    const { isLoadingFile, downloadFile } = useDownloadFile({ requestOptions });

    return (
        <Box sx={{ display: 'flex', gap: 1 }}>
            <Button
                color="info"
                variant="outlined"
                loading={isLoadingFile && downloadType.current === 'sintetico'}
                disabled={!hasReembolsos || (isLoadingFile && downloadType.current === 'analitico')}
                sx={{ px: 1, py: 0 }}
                onClick={() => {
                    downloadType.current = 'sintetico';

                    downloadFile({
                        newRequestOptions: { ...requestOptions, url: 'financeiro/apuracaolojapromocaovenda/consulta/exportar/xlsx' },
                        directDownload: true,
                    });
                }}
            >
                Relatório sintético
            </Button>

            <Button
                color="success"
                variant="outlined"
                sx={{ px: 1, py: 0 }}
                loading={isLoadingFile && downloadType.current === 'analitico'}
                disabled={!hasReembolsos || (isLoadingFile && downloadType.current === 'sintetico')}
                onClick={() => {
                    downloadType.current = 'analitico';

                    downloadFile({
                        newRequestOptions: { ...requestOptions, url: 'financeiro/apuracaolojapromocaoprodutovendawrapper/exportar/csv' },
                        directDownload: true,
                    });
                }}
            >
                Relatório analítico
            </Button>
        </Box>
    );
}
